<template>
    <ul class="rate list-inline" :class="containerClass">
        <li v-for="(s,k) in stars" :key="k" class="list-inline-item"><i :class="getClass(s)"></i></li>
    </ul>
</template>

<script>
    export default {
        props: {
            value: {default: function () { return true; }},
            containerClass: null,
        },
        computed:{
            stars: function() {
                return [1,2,3,4,5];
            },
        },
        watch: {
            value: function(newVal, oldVal) {
                this.value= newVal;
            },
        },
        mounted(){

        },
        methods: {
            getClass: function(k) {
                if(this.value >= k) {
                    return 'fas fa-star';
                } else if (this.value > (k-1)) {
                    return 'fas fa-star-half-alt';
                } else {
                    return 'far fa-star';
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
i {
    color: #ffcc00!important;
}
</style>
